var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { forwardRef, useEffect, } from 'react';
import { rcConfiguration } from '../config';
import { isShowJunoWarning } from './isShowJunoWarning';
function showDeprecated(_a) {
    var component = _a.component, target = _a.target, time = _a.time, comment = _a.comment, message = _a.message, level = _a.level;
    var showMessage = message ||
        "props => (" + target + ") be deprecated, that will be remove in " + time + " release" + (comment ? ", " + comment : '');
    rcConfiguration.WARNING_FUNCTION("JUNO [" + component + "]: " + showMessage, {
        level: level,
    });
}
export function logInDev(args, cb) {
    if (isShowJunoWarning) {
        showDeprecated(args);
        cb === null || cb === void 0 ? void 0 : cb();
    }
}
export var useDeprecatedLog = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (isShowJunoWarning) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(function () {
            logInDev.apply(void 0, __spread(args));
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    }
};
export function withDeprecatedCheck(Component, depreciates, source) {
    if (!isShowJunoWarning) {
        return Component;
    }
    var name = Component.displayName || source || '';
    return forwardRef(function (props, ref) {
        useEffect(function () {
            depreciates.forEach(function (_a) {
                var prop = _a.prop, comment = _a.comment, time = _a.time;
                var _b;
                if (props[prop] !== undefined &&
                    // * also not to be default value
                    props[prop] !== ((_b = Component.defaultProps) === null || _b === void 0 ? void 0 : _b[prop])) {
                    showDeprecated({
                        component: name,
                        target: prop,
                        time: time,
                        comment: comment,
                    });
                }
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return React.createElement(Component, __assign({}, props, { ref: ref }));
    });
}
